import React, {useEffect, useRef, useState} from 'react'
import testVideo from "../assets/video/test-video.mp4"
import {getComments, getPitchData} from "../lib/api";
import { useParams } from "react-router-dom";
import ChallengeDetails from "../components/ChallengeDetails";
import {ChatBubbleOutline} from "@mui/icons-material";
import JoinTheApp from "../components/JoinTheApp";
import {Helmet} from "react-helmet";


export default function Home() {

    let params = useParams();

    const [commentsResponseStatus, setCommentsResponseStatus] = useState("FETCHING")
    const [commentsData, setCommentsData] = useState([])
    const [serverResponseStatus, setServerResponseStatus] = useState("FETCHING")
    const [numberOfComments, setNumberOfComments] = useState(0)
    const [challengerUsername, setChallengerUsername] = useState("")
    const [challengeDescription, setChallengeDescription] = useState("")
    const [challengePitchData, setChallengePitchData] = useState({})
    const [pitchData, setPitchData] = useState({
        "user_profile": {
            "avatar": "not_found",
            "handle": "not_found",
        },
        "media": {
            "video": {
                "url": testVideo.url
            }
        }
    })
    // const [showModal, setShowModal] = useState("");
    const [playClassName, setPlayClassname] = useState("");
    const [videoAspectRatio, setVideoAspectRatio] = useState(5/9)
    const pitchVideo = useRef(null)

    const playVideo = () => {
        setPlayClassname(" play")
        pitchVideo.current.play()
    }
    const stopVideo = () => {
        setPlayClassname("")
        pitchVideo.current.pause()
        pitchVideo.current.currentTime = 0
    }
    const videoEnded = () => {
        setPlayClassname("")
        pitchVideo.current.pause()
        pitchVideo.current.currentTime = 0
    }

    const videoMetaDataLoaded = () => {
        setVideoAspectRatio(pitchVideo.current.videoWidth / pitchVideo.current.videoHeight)
    }

    useEffect(()=>{

        if(params.pitchId) {
            getPitchData(params.pitchId).then(apiResponse => {
                if(apiResponse.hasOwnProperty("error")){
                    if(apiResponse["error"] === 404){
                        setServerResponseStatus("NOT_FOUND")
                        console.log("serverResponseStatus -> NOT_FOUND.")
                    } else if(apiResponse["error"] === 401){
                        setServerResponseStatus("NOT_AUTHORIZED")
                        console.log("serverResponseStatus -> NOT_AUTHORIZED")
                    } else {
                        setServerResponseStatus("NETWORK_ERROR")
                    }
                }else {
                    setServerResponseStatus("SUCCESS")
                    setPitchData(apiResponse)
                    if(apiResponse["type"] === "challenge"){
                        setChallengePitchData(apiResponse)
                        setChallengerUsername(apiResponse["user_profile"]["handle"])
                        setChallengeDescription(apiResponse["description"])
                    }else if(apiResponse["type"] === "challenge_reply"){
                        setChallengerUsername(apiResponse["replying_to_user_profile"]["handle"])
                        setChallengeDescription(apiResponse["challenge_description"])
                    }

                }
            })
        }else {
            setServerResponseStatus("NO_PITCH_ID")
        }

    }, [params])

    useEffect(() => {
        if(pitchData && pitchData.hasOwnProperty("metrics")) {
            setNumberOfComments(pitchData["metrics"]["comments"])
        }
    },[pitchData])

    useEffect( () => {
        if(challengePitchData && challengePitchData.hasOwnProperty("metrics")){
            setChallengeDescription(challengePitchData["description"])
            setChallengerUsername(challengePitchData["user_profile"]["handle"])
        }

    }, [challengePitchData])

    useEffect(() => {
        if(numberOfComments > 0){
            getComments(params.pitchId).then(apiResponse => {
                if(apiResponse.hasOwnProperty("error")){
                    if(apiResponse["error"] === 404){
                        setCommentsResponseStatus("NOT_FOUND")
                    }else {
                        setServerResponseStatus("NETWORK_ERROR")
                    }
                }else {
                    setCommentsResponseStatus("SUCCESS")
                    setCommentsData(apiResponse["results"])
                }
            })
        }
    }, [params, numberOfComments])

    return (
        <div className="main-home">
            {serverResponseStatus === "SUCCESS" &&
                <Helmet>
                    {challengerUsername &&
                        <title>VIA Academy {challengerUsername && " | " + challengerUsername}</title>
                    }
                    <meta property="og:type" content="website"/>
                    {challengerUsername &&
                        <meta property="og:title"
                              content={"Check out " + challengerUsername + "'s Video on VIA Academy"}/>
                    }
                    {challengeDescription &&
                        <meta property="og:description" content={challengeDescription}/>
                    }
                    {pitchData
                        && pitchData.hasOwnProperty("user_profile")
                        && pitchData["user_profile"].hasOwnProperty("avatar")
                        &&
                        <meta property="og:image" content={pitchData["user_profile"]["avatar"]}/>
                    }
                </Helmet>
            }
            <main className="content">
                <div className="container container-md">
                    <div className="row row-start">
                        <div className="col">
                            {serverResponseStatus === "SUCCESS" &&
                                <div className="phone-container">
                                    <div className="card-video-header"></div>
                                <div style={{aspectRatio: videoAspectRatio}} className={"card-video" + playClassName}>
                                    <div className="user-card">
                                        <div className="user-card__photo">
                                            <img src={pitchData["user_profile"]["avatar"]} alt="User name"/>
                                        </div>
                                        {/*<p className="user-card__link">*/}
                                        {/*    {"@" + pitchData["user_profile"]["handle"]}*/}
                                        {/*</p>*/}
                                        <div className="user-card__info">
                                            <span style={pitchData["user_profile"]["playing_position"] && pitchData["user_profile"]["playing_position"].length === 3 ? {fontSize: '0.6em', paddingBottom: '2%'}: {}}>{ pitchData["user_profile"]["playing_position"]}</span>
                                            {/*<div className="img-wrap img-wrap--logo">*/}
                                            {/*    <img src={pitchData["user_profile"]["organisation"]["avatar"]} alt={pitchData["user_profile"]["organisation"]} />*/}
                                            {/*</div>*/}
                                            <div className="img-wrap img-wrap--flag">
                                                <img src={pitchData["user_profile"]["nationality"]["flag"]} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="video-control play-button" onClick={playVideo}></button>
                                    <button className="video-control stop-button" onClick={stopVideo}></button>
                                    <div className="card-video__media">
                                        <img src={pitchData["media"]["video"]["frame_image"]["url"]} alt="Challenger video"/>
                                        <video ref={pitchVideo} className={"video" + playClassName} onEnded={videoEnded} onLoadedMetadata={videoMetaDataLoaded} controls={true} controlsList="nodownload noplaybackrate" disablePictureInPicture={true}>
                                            <source src={pitchData["media"]["video"]["url"]} type="video/mp4"/>
                                            Your browser doesn't support HTML5 video tag.
                                        </video>
                                    </div>
                                </div>
                                <div className="card-video-description">
                                    <ChallengeDetails challengerUsername={challengerUsername}
                                                      description={challengeDescription}
                                                      sharerOrganisationAvatar={pitchData["user_profile"]["avatar"]}
                                                      sharerUsername={pitchData["user_profile"]["handle"]}
                                                      sharerPosition={pitchData["user_profile"]["playing_position"]}
                                                      sharerFlag={pitchData["user_profile"]["nationality"]["flag"]}
                                    />
                                </div>
                                </div>
                            }
                            {serverResponseStatus !== "SUCCESS" &&
                                <p>&nbsp;</p>
                            }
                        </div>
                        { serverResponseStatus === "NOT_FOUND" &&
                            <div className="col col-comments">
                                <p className="section-title"><strong>The requested video could not be found. Please double check that the link has been copied correctly.</strong></p>
                                <JoinTheApp/>
                            </div>
                        }
                        { serverResponseStatus === "NOT_AUTHORIZED" &&
                            <div className="col col-comments">
                                <p className="section-title"><strong>Sorry, this video is for Followers only. Download the app and start following to see videos from other players.</strong></p>
                                <JoinTheApp/>
                            </div>
                        }
                        { serverResponseStatus === "NETWORK_ERROR" &&
                            <div className="col col-comments">
                                <p className="section-title"><strong>Communication Error. The server request could not be completed at this moment. This may be cause by a lack of network connectivity.</strong></p>
                                <JoinTheApp/>
                            </div>
                        }
                        { serverResponseStatus === "NO_PITCH_ID" &&
                            <div className="col col-comments">
                                <p className="section-title"><strong>Oops!</strong></p>
                                <p className="section-title">The video share link is not formatted correctly. Please double check that the link has been copied correctly.</p>
                                <JoinTheApp/>
                            </div>
                        }
                        { serverResponseStatus === "SUCCESS" &&

                            <div className="col col-comments">
                                <p className="section-title"><strong><ChatBubbleOutline fontSize="large" className="comments-chat-bubble"/> Academy Comments</strong></p>
                                { numberOfComments === 0 &&
                                    <div className="card-comment last-comment">
                                        <strong>There are no comments on this video</strong>
                                    </div>
                                }
                                { numberOfComments > 0 && commentsResponseStatus !== "SUCCESS" && commentsResponseStatus !== "FETCHING" &&
                                    <div className="card-comment last-comment">
                                        <strong>There are {numberOfComments} comments on this video which could not be loaded due to network failure. Please try again another time.  </strong>
                                    </div>
                                }
                                { numberOfComments > 0 && commentsResponseStatus === "SUCCESS" &&
                                    commentsData.map( (comment, i) =>
                                    <div key={"comment-" + i} className={"card-comment" + (numberOfComments === (i + 1) ? " last-comment": "")}>
                                        <div className="card-comment__logo">
                                            <img src={comment["posted_by"]["avatar"]}
                                                 alt={comment["posted_by"]["handle"] + "'s Avatar"}/>
                                        </div>
                                        <div className="card-comment__content">
                                            <div className="card-comment__title">
                                                <strong>{comment["posted_by"]["handle"]}</strong>
                                                <strong className="dot">•</strong>
                                                <span className="text-muted">1h</span>
                                            </div>
                                            <p>{comment["text"]}</p>
                                        </div>
                                    </div>
                                    )
                                }
                                <JoinTheApp/>
                            </div>
                        }
                    </div>
                </div>
            </main>
        </div>
    )
}